import React from "react";
import { Box } from "@mui/material";

const SelectionRectOverlay = ({ rect, activeEditorTool }) => {
  if (!rect) return null;

  return (
    <>
      {activeEditorTool === "line" ? (
        <Box
          sx={{
            padding: "4px",
            position: "absolute",
            left: `${rect.left}px`,
            top: `${rect.top}px`,
          }}
        >
          <Box
            sx={{
              width: `${rect.width}px`,
              height: `${rect.height}px`,
              borderTop: "1px solid #000",
            }}
          />
        </Box>
      ) : (
        <Box
          sx={{
            position: "absolute",
            left: `${rect.left}px`,
            top: `${rect.top}px`,
            width: `${rect.width}px`,
            height: `${rect.height}px`,
            border:
              activeEditorTool === "rectangle"
                ? "1px solid #000"
                : "2px dotted blue",
          }}
        />
      )}
    </>
  );
};

export default SelectionRectOverlay;
